import React from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'

function AddMeal() {
    const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "name", title: "اسم الصنف", type: "text" },
        { id: "category", title: "التصنيف", type: "select", options: ["فطار", "غداء", "عشاء"] },
        { id: "description", title: "الوصف", type: "textarea" },
      ],
    },
  ];

  return (
        <div>
        <AuthNavbar/>
          <Container>
                    <CustomHeader
          title={"إضافة صنف جديدة"}
          subtitle={"قم بتنسيق تحفة فنية جديدة في فنون الطهي لمجموعة الأكاديمية."}
          downloadData={false}
        />
        <CustomForm
formStructure={infoData}
image={true}
        />
            </Container>
            </div>
  )
}

export default AddMeal